import type { FC } from 'react';
import { useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { v4 } from 'uuid';
import { API } from '../api';
import { sleep } from '../async';
import { cx } from '../cx';
import { useOpenModal } from '../next-modal';
import { Button } from './button';
import { Input } from './input';
import { message } from './message';
import { appI18n } from '../i18n';

const PayAccessFeeCodeId = v4();
export const useOpenPayAccessFeeCode = (config: { isLogin: boolean; openLogin: Function }) => {
  const openModal = useOpenModal();

  return useCallback(
    (onFinish?: () => void) => {
      if (!config.isLogin) {
        config.openLogin();
        return;
      }
      openModal.modal({
        modalId: PayAccessFeeCodeId,
        content: () => <PayAccessFeeCode onFinish={onFinish} />,
      });
    },
    [config, openModal]
  );
};

const PayAccessFeeCode: FC<{ onFinish?: () => void }> = (props) => {
  const openModal = useOpenModal();

  const active = async (value: string) => {
    if (!value) return;
    if (message.exists(PayAccessFeeCodeId)) return;
    message.success({ key: PayAccessFeeCodeId, content: appI18n.t('pkg_common.redeem.redeeming') });
    await API.infra.putWelfareCode(value, {});
    message.success(appI18n.t('pkg_common.redeem.redeem_success') as string);
    props.onFinish?.();
    await sleep(1000);
    location.reload();
  };

  return (
    <form
      className={cx('p-6 space-y-5 text-t2', isMobile ? 'w-[80vw]' : 'w-72')}
      onSubmit={(e) => {
        e.preventDefault();
        // @ts-ignore is input
        void active(e.target[0]?.value as string);
      }}
    >
      <div className="text-t1-medium">{appI18n.t('pkg_common.redeem.use_code')}</div>
      <Input
        className="py-2"
        autoFocus
        placeholder={appI18n.t('pkg_common.redeem.enter_code') as string}
      />
      <div className="grid grid-cols-2 gap-2">
        <Button colorType="active" type="submit">
          {appI18n.t('pkg_common.redeem.confirm_redeem')}
        </Button>
        <Button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openModal.closeModal(PayAccessFeeCodeId);
          }}
        >
          {appI18n.t('pkg_common.btn.cancel')}
        </Button>
      </div>
    </form>
  );
};
